import { ACTION_TYPES } from '../Constants';
import { fetchAllCareersInMunicipality } from '../Utils/fetcherUtil';

const fetchCareersStarted = () => (
  { type: ACTION_TYPES.FETCH_CAREERS_STARTED }
);

const fetchCareersSucceeded = data => (
  { type: ACTION_TYPES.FETCH_CAREERS_SUCCEEDED, data }
);

const fetchCareersFailed = error => (
  { type: ACTION_TYPES.FETCH_CAREERS_FAILED, error }
);

export const fetchCareers = municipalityName => (dispatch) => {
  dispatch(fetchCareersStarted());
  fetchAllCareersInMunicipality(municipalityName).then((result) => {
    if (result.status === 200) {
      dispatch(fetchCareersSucceeded(result.data));
    }
  }).catch((error) => {
    dispatch(fetchCareersFailed());
    console.log(error);
  });
};

export const openQuestionModal = () => ({
  type: ACTION_TYPES.QUESTION_MODAL_OPENED,
});
export const closeQuestionModal = () => ({
  type: ACTION_TYPES.QUESTION_MODAL_CLOSED,
});
export const openSubscriptionModal = () => ({
  type: ACTION_TYPES.SUBSCRIPTION_MODAL_OPENED,
});
export const closeSubscriptionModal = () => ({
  type: ACTION_TYPES.SUBSCRIPTION_MODAL_CLOSED,
});
export const openGdprModal = () => ({
  type: ACTION_TYPES.GDPR_MODAL_OPENED,
});
export const closeGdprModal = () => ({
  type: ACTION_TYPES.GDPR_MODAL_CLOSED,
});



// WEBPACK FOOTER //
// ./src/Actions/CareerActions.js